import wixData from 'wix-data';
import wixLocation from 'wix-location';
import wixWindow from 'wix-window';
import {timeline} from 'wix-animations'
import {gethashtag} from 'backend/gethashtag'
import {session} from 'wix-storage';

var colorhashtag
let keyword
let year
let month
let category
let page = 0
let click = 0
let totalresults
let totalpage

$w.onReady(function () {
	gethashtag().then(function(h) {colorhashtag = h
	if(wixWindow.formFactor !== "Mobile"){$w("#repeater9").data = h}
	loadcate()

	let query = wixLocation.query;
	keyword = query.keyword
	year = query.year
	month = query.month
	category = query.category
	if (keyword == 'none') {keyword = '', $w("#input1").value = keyword} else {$w("#input1").value = keyword}
	$w("#dropdown4").value = year
	if (month == 'all') {$w("#dropdown7").value = '不限'} else {$w("#dropdown7").value = month}
	if (category == 'all') {$w("#dropdown5").value = '全部類別'} else {$w("#dropdown5").value = category}
	let Rmonth
	let Rcategory
	if (month == 'all') {Rmonth = '所有'} else {Rmonth = month}
	if (category == 'all') {Rcategory = '所有'} else {Rcategory = category}
	if (month == 'all') {$w("#text116").text = '搜尋結果－' + year + ' 年，有關' + keyword + '的' + Rcategory + '事件'} 
	else {$w("#text116").text = '搜尋結果－' + year + ' 年 ' + Rmonth + ' 月，有關' + keyword + '的' + Rcategory + '事件'}
	countsearch()
	
	});


$w("#repeater1").onItemReady( ($item, itemData, index) => {
		$item("#image14").src = itemData.cover
		$item("#text76").text = itemData.title
		$item("#text77").text = itemData.description
		if (itemData.category.indexOf(',') > -1) {
			const split = itemData.category.split(',')
			const hashtag = split.map(item => {return {label: String(item), value:String(item)}}) 
			$item("#selectionTags1").options = hashtag
			var c = colorhashtag.find(x => x.hashtag === hashtag[0].label)
      		$item("#selectionTags1").style.backgroundColor = c.color
		} else {
			const hashtag = [{label: itemData.category, value: itemData.category}]
			$item("#selectionTags1").options = hashtag
			var category = itemData.category    
     		var c = colorhashtag.find(x => x.hashtag === category)
     		$item("#selectionTags1").style.backgroundColor = c.color}
		$item("#image14").link = '/h/' + itemData.title
		$item("#image14").target = "_blank"
		let date = itemData.dateofissue;
		let day = date.getDate();
		let month = date.getMonth()+1;
		let year = date.getFullYear();
		$item("#text81").text =  year + "年" + month + "月" + day+ "日"
	})

$w("#repeater9").onItemReady( ($item, itemData, index) => {
$item("#button47").label = itemData.hashtag
})
});


function countsearch() {
let startmonth
let endmonth
keyword = $w("#input1").value
if ($w("#dropdown5").value == '全部類別') {category = ''} else {category = $w("#dropdown5").value}
if ($w("#dropdown7").value == '不限') {startmonth = 0, endmonth = 11} else {startmonth = Number($w("#dropdown7").value)-1, endmonth = Number($w("#dropdown7").value)-1}

wixData.query("hongkonghistory")
  .limit(1000)
  .contains('title', $w("#input1").value)
  .contains('category', category)
  .between('dateofissue',new Date(year,startmonth,1),new Date(year,endmonth+1,0,23,59,59))
  .ascending('dateofissue')
  .or(wixData.query("hongkonghistory")
  .limit(1000)
  .contains('description', $w("#input1").value)
  .contains('category', category)
  .between('dateofissue',new Date(year,startmonth,1),new Date(year,endmonth+1,0,23,59,59))
  .ascending('dateofissue'))
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
	totalresults = results.items.length
    $w("#text96").text = '共 ' + totalresults + ' 個結果'
	totalpage = Math.floor(totalresults)/20
	const page = new Array
	for (let i = 0; i < totalpage; i++) {page[i] = {label: String(Number(i+1)), value:String(Number(i+1))}}
	$w("#dropdown2").options = page
	search()
    } else {$w("#text96").text = '共 0 個結果', $w("#image15").hide()}
})
}

function search() {
let startmonth
let endmonth
keyword = $w("#input1").value
if ($w("#dropdown5").value == '全部類別') {category = ''} else {category = $w("#dropdown5").value}
if ($w("#dropdown7").value == '不限') {startmonth = 0, endmonth = 11} else {startmonth = Number($w("#dropdown7").value)-1, endmonth = Number($w("#dropdown7").value)-1}

wixData.query("hongkonghistory")
  .limit(20)
  .skip(page*20)
  .contains('title', $w("#input1").value)
  .contains('category', category)
  .between('dateofissue',new Date(year,startmonth,1),new Date(year,endmonth+1,0,23,59,59))
  .ascending('dateofissue')
  .or(wixData.query("hongkonghistory")
  .limit(20)
  .skip(page*20)
  .contains('description', $w("#input1").value)
  .contains('category', category)
  .between('dateofissue',new Date(year,startmonth,1),new Date(year,endmonth+1,0,23,59,59))
  .ascending('dateofissue'))
  .find()
  .then( (results) => {
    if(results.items.length > 0) {
	$w("#repeater1").data = results.items
	$w("#repeater1").show()
	$w("#group1").show()
	$w("#image15").hide()
    }
})
}

function loadcate() {
      const allcate = [{label: '全部類別', value: '全部類別'}]
      const data = colorhashtag.map(item => {return {label: String(item.hashtag), value:String(item.hashtag)}})
$w("#dropdown5").options = allcate.concat(data)
$w("#dropdown5").value = '全部類別'
}

export function button13_click(event) {
keyword = $w("#input1").value
if ($w("#dropdown4").value == '不限') {year = 'all'} else {year = $w("#dropdown4").value}
if ($w("#dropdown7").value == '不限') {month = 'all'} else {month = $w("#dropdown7").value}
if ($w("#dropdown5").value == '全部類別') {category = 'all'} else {category = $w("#dropdown5").value}
session.setItem("url", '/memorabiliasearching?keyword=' + keyword + '&year=' + year + '&month=' + month + '&category=' + category);
wixLocation.to('/rd')
}

export function dropdown2_change(event) {
page = Number($w("#dropdown2").value)-1
search()
$w("#text96").scrollTo()
}